/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import Processes from './modules/Processes';
import agendamentoPadrao from './modules/agendamento/padrao';
import agendamentoRelatorio from './modules/agendamentoRelatorio';
import armazenagem from './modules/armazenagem';
import Auth from './modules/auth';
import bingMap from './modules/bingMap';
import moeda from './modules/cadastro-basico/moeda';
import unidadeMedida from './modules/cadastro-basico/unidadeMedida';
import cambio from './modules/cambio';
import colunasExcel from './modules/colunasExcel';
import containers from './modules/containers';
import core from './modules/core';
import cotacao from './modules/cotacao';
import crc from './modules/crc';
import despesasImportacaoDetalhamento from './modules/despesasImportacaoDetalhamento';
import empresas from './modules/empresas';
import perguntasRespostas from './modules/empresas/perguntasRespostas';
import questionarios from './modules/empresas/questionarios';
import estoque from './modules/estoque';
import excel from './modules/excel';
import fechamento from './modules/fechamento';
import ged from './modules/ged';
import gestaoLI from './modules/gestaoLI';
import idiomas from './modules/idiomas';
import incentivoFiscal from './modules/incentivo-fiscal';
import invoices from './modules/invoices';
import modeloRelatorio from './modules/modeloRelatorio';
import ncm from './modules/ncm';
import notificacoes from './modules/notificacoes';
import numerario from './modules/numerario';
import paginacao from './modules/paginacao';
import paginacaoModal from './modules/paginacao-modal';
import patchNotes from './modules/patchNotes';
import portos from './modules/portos';
import processosAfiliados from './modules/processo/afiliados';
import processosComissoes from './modules/processo/comissoes';
import valorAduaneiro from './modules/processo/valorAduaneiro';
import produtos from './modules/produtos';
import sap_alteracoes from './modules/sap_alteracoes';
import simulacao from './modules/simulacao';
import solicitacaoProcesso from './modules/solicitacaoProcesso';
import tarefas from './modules/tarefas';
import usuario from './modules/usuario';
import mercadoHoje from './modules/mercadoHoje';
import processoPreFaturamento from './modules/processo/preFaturamento';
import previsaoDemandaDomestica from './modules/armazenagem/previsaoDemandaDomestica';
import processosPendentes from './modules/processosPendentes';
import armazenagemAcuraciaEstoque from './modules/Armazenamento/acuraciaEstoque'

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  modules: {
    core,
    bingMap,
    Auth,
    Processes,
    solicitacaoProcesso,
    excel,
    cotacao,
    agendamentoRelatorio,
    usuario,
    armazenagem,
    estoque,
    modeloRelatorio,
    fechamento,
    invoices,
    idiomas,
    valorAduaneiro,
    portos,
    cambio,
    numerario,
    agendamentoPadrao,
    ncm,
    notificacoes,
    tarefas,
    produtos,
    gestaoLI,
    paginacao,
    paginacaoModal,
    ged,
    containers,
    sap_alteracoes,
    colunasExcel,
    empresas,
    questionarios,
    perguntasRespostas,
    patchNotes,
    incentivoFiscal,
    moeda,
    unidadeMedida,
    crc,
    simulacao,
    processosAfiliados,
    mercadoHoje,
    processosComissoes,
    despesasImportacaoDetalhamento,
    processoPreFaturamento,
    previsaoDemandaDomestica,
    processosPendentes,
    armazenagemAcuraciaEstoque,
  },
  state: {
    sidebarOpen: true,
    loading: false,
    skeleton: false,
    globalError: '',
    modalOpened: false,
    drawerOpened: false,
    versaoTrinity: '',
  },
  mutations: {
    TOGGLE_SIDEBAR(state, payload) {
      state.sidebarOpen = payload;
    },
    TOGGLE_LOADING(state, payload) {
      if (state.loading !== payload) { state.loading = payload; }
    },
    TOGGLE_SKELETON(state, payload) {
      if (state.skeleton !== payload) { state.skeleton = payload; }
    },
    UPDATE_GLOBAL_ERROR(state, payload) {
      state.globalError = payload;
    },
    UPDATE_MODAL(state, payload) {
      state.modalOpened = payload;
    },
    TOGGLE_DRAWER(state, payload) {
      state.drawerOpened = payload;
    },
    SET_VERSAO_TRINITY(state, payload) {
      state.versaoTrinity = payload;
    },
  },
  getters: {
    getModalOpened(state) {
      return state.modalOpened;
    },
  },
  actions: {
    initializeStore({ dispatch }) {
      dispatch('toggleLoading', null);
      dispatch('Auth/initializeStore', null);
      dispatch('bingMap/initializeStore', null);
    },
    toggleSidebar(context, payload) {
      context.commit('TOGGLE_SIDEBAR', payload);
    },
    toggleLoading(context, payload) {
      context.commit('TOGGLE_LOADING', payload);
    },
    setGlobalError(context, payload) {
      context.commit('UPDATE_GLOBAL_ERROR', payload);
    },
    toggleModal(context, payload) {
      context.commit('UPDATE_MODAL', payload);
    },
    toggleDrawer(context, payload) {
      context.commit('TOGGLE_DRAWER', payload);
    },
    toggleSkeleton(context, payload) {
      context.commit('TOGGLE_SKELETON', payload);
    }
  },
  plugins: [createPersistedState({
    paths: ['Auth', 'portos', 'solicitacaoProcesso.rascunhos', 'cotacao'],
  })],
});
